'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = maker;

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _makerActions = require('../actions/makerActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function maker(state, action) {
	switch (action.type) {

		case _makerActions.UPDATE_REPORT:
			return _extends({}, state, action.report);

		case _makerActions.ADD_COMPONENT:
			var newComponents = state.components.slice();
			var component = _extends({}, action.component);
			component.id = _underscore2.default.uniqueId('fresh_');
			newComponents.push(component);

			return _extends({}, state, {
				components: newComponents
			});

		case _makerActions.REMOVE_COMPONENT:
			var newComponents = [].concat(_toConsumableArray(state.components.slice(0, action.index)), _toConsumableArray(state.components.slice(action.index + 1)));

			return _extends({}, state, {
				components: newComponents
			});

		case _makerActions.UPDATE_COMPONENT:
			var newComponents = state.components.slice();
			newComponents[action.index] = action.component;
			return _extends({}, state, {
				components: newComponents
			});

		case _makerActions.MOVE_COMPONENT:

			if (action.direction == 'up' && action.index > 0) {

				var newComponents = [].concat(_toConsumableArray(state.components.slice(0, action.index - 1)), _toConsumableArray(state.components.slice(action.index, action.index + 1)), _toConsumableArray(state.components.slice(action.index - 1, action.index)), _toConsumableArray(state.components.slice(action.index + 1)));
			} else if (action.direction == 'down' && action.index < state.components.length - 1) {

				var newComponents = [].concat(_toConsumableArray(state.components.slice(0, action.index)), _toConsumableArray(state.components.slice(action.index + 1, action.index + 2)), _toConsumableArray(state.components.slice(action.index, action.index + 1)), _toConsumableArray(state.components.slice(action.index + 2)));
			} else {

				var newComponents = state.components;
			}

			return _extends({}, state, {
				components: newComponents
			});

		case _makerActions.SUBMIT_REPORT:
			console.log('make reducer function for this');
			return state;

		default:
			return state;
	}
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/reducers/makerReducer.js
// module id = 585
// module chunks = 0